import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTheme } from '../hooks/useTheme';
import Header from '../components/landing/Header';
import Footer from '../components/landing/Footer';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { Divider } from 'primereact/divider';
import { Button } from 'primereact/button';

const ContactoPage = () => {
    const { theme, toggleTheme } = useTheme();

    return (
        <div className={`landing-page theme-${theme}`}>
            <Helmet>
                <title>Contáctanos – Laptops.pe</title>
                <meta name="description" content="Canales oficiales de contacto de Laptops.pe: WhatsApp, correo y redes sociales. Cobertura nacional y horarios de atención." />
                <link rel="canonical" href={`${process.env.REACT_APP_SITE_URL || ''}/contacto`} />
                <meta name="robots" content="index, follow" />
            </Helmet>

            <Header theme={theme} onToggleTheme={toggleTheme} />

            <main className="landing-main">
                <div className="py-6">
                    <div className="text-center mb-5">
                        <h1 className="text-4xl lg:text-5xl font-bold text-primary mb-2">
                            <span role="img" aria-label="telefono">📞</span> Contáctanos – Laptops.pe
                        </h1>
                        <p className="text-700">Tu confianza es lo más importante.</p>
                    </div>

                    <Card className="mb-4">
                        <div className="p-4">
                            <p className="text-700 line-height-3">
                                Sabemos que comprar una laptop en línea puede generar dudas, por eso ponemos a tu disposición múltiples canales oficiales para brindarte atención rápida, personalizada y segura.
                            </p>
                            <p className="text-700 line-height-3">
                                Somos una empresa operada por <strong>DIGITAL WINS E.I.R.L. (RUC 20612859630)</strong>, dedicada a la <strong>venta especializada de laptops y accesorios tecnológicos en todo el Perú</strong>.
                            </p>
                            <p className="text-700 line-height-3">
                                Contamos con <strong>centros de distribución</strong> en <strong>Lima, Arequipa, Juliaca, Tacna, Cusco, Trujillo y Huancayo</strong>, lo que nos permite despachar productos con rapidez a cualquier región del país.
                            </p>
                            <p className="text-700 line-height-3">
                                Dirección fiscal: <strong>PJ. EL TRIUNFO MZA. S LOTE. 37A INT. 502 URB. SAN LUIS</strong>, distrito <strong>San Luis</strong>, provincia <strong>Lima</strong>, departamento <strong>Lima</strong>. Oficinas administrativas: <strong>Urb. Brisas de Huachipa Mz. B Lte. 14</strong>, distrito <strong>Lurigancho</strong>, provincia <strong>Lima</strong>, departamento <strong>Lima</strong>.
                            </p>
                        </div>
                    </Card>

                    <Panel header="🕐 Horario de atención" className="mb-4">
                        <p className="text-700">
                            Atendemos tus consultas <strong>de lunes a sábado de 9:00 a.m. a 8:00 p.m.</strong>
                        </p>
                        <p className="text-700">
                            Los domingos y feriados respondemos únicamente consultas urgentes relacionadas con entregas o pedidos en curso.
                        </p>
                    </Panel>

                    <Panel header="💬 Canales de atención oficiales" className="mb-4">
                        <div className="grid">
                            <div className="col-12 md:col-6">
                                <Card className="mb-3">
                                    <div className="p-4">
                                        <div className="flex align-items-center gap-2 mb-3">
                                            <i className="pi pi-whatsapp text-2xl text-primary" aria-hidden="true"></i>
                                            <h3 className="m-0 text-xl">📱 WhatsApp (Atención personalizada)</h3>
                                        </div>
                                        <p className="text-700">Comunícate directamente con un asesor comercial o de soporte:</p>
                                        <div className="flex gap-2 align-items-center">
                                            <a href="https://wa.me/51978326796" target="_blank" rel="noopener noreferrer" className="text-primary">
                                                https://wa.me/51978326796
                                            </a>
                                            <Button as="a" href="https://wa.me/51978326796" target="_blank" rel="noopener noreferrer" label="Abrir WhatsApp" icon="pi pi-external-link" className="p-button-sm p-button-outlined" />
                                        </div>
                                        <p className="text-700 mt-2">Resolvemos dudas sobre disponibilidad, precios, envíos, medios de pago y estados de pedido.</p>
                                    </div>
                                </Card>
                            </div>

                            <div className="col-12 md:col-6">
                                <Card className="mb-3">
                                    <div className="p-4">
                                        <div className="flex align-items-center gap-2 mb-3">
                                            <i className="pi pi-envelope text-2xl text-primary" aria-hidden="true"></i>
                                            <h3 className="m-0 text-xl">✉️ Correo electrónico</h3>
                                        </div>
                                        <p className="text-700">Para consultas detalladas o requerimientos administrativos:</p>
                                        <p className="text-700">
                                            📩 <a href="mailto:soporte@laptops.pe">soporte@laptops.pe</a>
                                        </p>
                                    </div>
                                </Card>
                            </div>
                        </div>

                        <Divider />

                        <Card>
                            <div className="p-4">
                                <div className="flex align-items-center gap-2 mb-3">
                                    <i className="pi pi-share-alt text-2xl text-primary" aria-hidden="true"></i>
                                    <h3 className="m-0 text-xl">💻 Redes sociales oficiales</h3>
                                    </div>
                                <p className="text-700">Síguenos para conocer ofertas, lanzamientos y novedades:</p>
                                <ul className="list-none m-0 p-0 text-700">
                                    <li className="mb-2">TikTok: <a href="https://www.tiktok.com/@laptops_pe" target="_blank" rel="noopener noreferrer">https://www.tiktok.com/@laptops_pe</a></li>
                                    <li className="mb-2">Facebook: <a href="https://www.facebook.com/laptops.pe" target="_blank" rel="noopener noreferrer">https://www.facebook.com/laptops.pe</a></li>
                                    <li>Instagram: <a href="https://www.instagram.com/laptops.pe" target="_blank" rel="noopener noreferrer">https://www.instagram.com/laptops.pe</a></li>
                                </ul>
                                <p className="text-700 mt-3">
                                    ⚠️ <em>Atención:</em> solo atendemos consultas a través de los canales oficiales mencionados arriba. No realizamos ventas ni coordinaciones por cuentas personales o no verificadas.
                                    <br />
                                    📌 <strong>Transparencia:</strong> Laptops.pe es una marca de <strong>DIGITAL WINS E.I.R.L.</strong>
                                </p>
                            </div>
                        </Card>
                    </Panel>

                    <Panel header="🚚 Cobertura nacional" className="mb-4">
                        <p className="text-700">Realizamos envíos a todo el Perú mediante operadores logísticos confiables.</p>
                        <p className="text-700">Puedes comprar desde cualquier ciudad y recibir tu laptop de forma segura en tu domicilio o agencia más cercana.</p>
                        <p className="text-700">Nuestros principales <strong>centros de distribución</strong> están ubicados en:</p>
                        <ul className="list-disc ml-4 text-700">
                            <li><strong>Lima</strong> (central de despacho nacional)</li>
                            <li><strong>Arequipa</strong></li>
                            <li><strong>Trujillo</strong></li>
                            <li><strong>Cusco</strong></li>
                            <li><strong>Juliaca</strong></li>
                            <li><strong>Tacna</strong></li>
                            <li><strong>Huancayo</strong></li>
                        </ul>
                    </Panel>

                    <Panel header="🤝 Estamos aquí para ayudarte" className="mb-4">
                        <p className="text-700">En <strong>Laptops.pe</strong>, queremos que cada cliente se sienta seguro al comprar en línea.</p>
                        <p className="text-700">Todo nuestro equipo está comprometido con ofrecer una experiencia transparente, confiable y sin complicaciones, desde que eliges tu laptop hasta que la recibes en tus manos.</p>
                        <p className="text-700">📲 Escríbenos, estaremos encantados de ayudarte.</p>
                    </Panel>
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default ContactoPage;
